(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_contests-entry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('contest-entry')) {
    // Contest one-way entry: Enter → locked "Entry Received". There is no
    // cancel — once the customer tag lands, the block renders a plain
    // disabled confirmation instead of this element. The button is
    // server-rendered in a disabled loading state (spinner visible, label
    // hidden) and only armed here, so a broken script can never show a
    // clickable Enter. Twin of <mg-entry> in blocks/events.liquid —
    // deliberately duplicated so each feature is self-contained.
    //
    // Host: hidden [data-contest-form] wrapper rendered above, holding a
    // Shopify Forms mount div the app embed mounts a React form into
    // (inside an open shadow root). Submissions carry the contest handle —
    // Flow adds the contest-<handle> tag.
    const LABELS = { enter: 'Enter', received: 'Entry Received' }

    customElements.define('contest-entry', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button')
        if (!this.button) return
        // A submission made moments ago may not be reflected in the
        // server-rendered state yet (the Flow tag write takes a few
        // seconds) — bridge that gap by landing on the confirmation, but
        // only for 2 minutes: an expired or malformed value is dropped so
        // a tag removed in admin can't stay masked by this tab. Scoped
        // per customer so a shared computer never shows another account's
        // state.
        this.storeKey = `contest-entry:${this.dataset.scope || 'anon'}:${this.dataset.tag}`
        let stored = null
        try { stored = sessionStorage.getItem(this.storeKey) } catch (e) { /* storage blocked */ }
        const age = Date.now() - Number(stored)
        if (stored !== null && age >= 0 && age < 120000) {
          this.lock()
          return
        }
        try { sessionStorage.removeItem(this.storeKey) } catch (e) { /* storage blocked */ }
        this.button.addEventListener('click', () => this.act())
        this.setBusy(false)
      }

      async act() {
        if (window.Shopify && window.Shopify.designMode) {
          this.say('Entry buttons are disabled in the theme editor.')
          return
        }
        if (this.busy || this.locked) return
        this.setBusy(true)

        const form = await this.waitForForm(8000)
        if (!form) {
          this.fail("Sorry — that didn't work. Please refresh the page and try again.")
          return
        }
        const email = this.emailInput(form)
        if (this.dataset.email && email) this.fill(email, this.dataset.email)
        const field = this.fieldInput(form, email)
        if (!field) {
          this.fail('The entry form is missing its Contest field.')
          return
        }
        this.fill(field, this.dataset.handle)

        const confirmed = this.watchSuccess(form)
        if (typeof form.requestSubmit === 'function') form.requestSubmit()
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))

        if (!(await confirmed)) {
          this.fail("That didn't seem to go through — please refresh the page and try again.")
          return
        }
        try { sessionStorage.setItem(this.storeKey, String(Date.now())) } catch (e) { /* storage blocked */ }
        this.lock()
      }

      // Terminal state: the disabled button carries the confirmation.
      // locked is set before the busy flag clears so setBusy can never
      // re-arm the button. aria-disabled triggers base.css's native
      // dimming, which covers button-secondary (its :disabled doesn't).
      lock() {
        this.locked = true
        this.say('')
        this.setBusy(false)
        this.button.setAttribute('aria-disabled', 'true')
        const label = this.querySelector('.contest-entry__label')
        if (label) label.textContent = LABELS.received
      }

      fail(message) {
        this.say(message)
        this.setBusy(false)
      }

      // Doubles as the arming step: the server renders the button disabled
      // with the spinner showing, and the first setBusy(false) reveals the
      // live Enter button.
      setBusy(busy) {
        this.busy = busy
        this.button.disabled = busy || this.locked === true
        if (busy) this.button.setAttribute('aria-busy', 'true')
        else this.button.removeAttribute('aria-busy')
        const label = this.querySelector('.contest-entry__label')
        const spinner = this.querySelector('.contest-entry__spinner')
        if (label) label.hidden = busy
        if (spinner) spinner.hidden = !busy
      }

      say(message) {
        const status = this.querySelector('.contest-entry__status')
        if (status) status.textContent = message
      }

      // --- Shopify Forms plumbing. The app embed builds each form as a
      // React app inside an open shadow root; fields commit after the
      // <form> shell does, and shadow renders are invisible to light-DOM
      // observers, so readiness is polled.

      hosts() {
        return Array.from(document.querySelectorAll('[data-contest-form]'))
      }

      scan(host) {
        const direct = host.querySelector('form')
        if (direct) return direct
        for (const element of host.querySelectorAll('*')) {
          if (element.shadowRoot) {
            const form = element.shadowRoot.querySelector('form')
            if (form) return form
          }
        }
        return null
      }

      // The email input isn't always type="email" — the current Forms
      // renderer emits a plain text input identified only by id="email".
      emailInput(form) {
        return form.querySelector('input[type="email"], input[name*="email" i], input[id*="email" i]')
      }

      fieldInput(form, email) {
        const texts = Array.from(form.querySelectorAll('input[type="text"], input:not([type])'))
          .filter((input) => input !== email)
        const named = texts.find((input) => {
          const label = input.labels && input.labels[0] ? input.labels[0].textContent : ''
          return /contest/i.test(`${input.name} ${input.id} ${input.placeholder} ${label}`)
        })
        if (named) return named
        return texts.length === 1 ? texts[0] : null
      }

      ready(form) {
        if (!form) return false
        const email = this.emailInput(form)
        return !!email && !!this.fieldInput(form, email)
      }

      hasSuccess(host) {
        const selector = '[class*="success" i], [data-success]'
        if (host.querySelector(selector)) return true
        for (const element of host.querySelectorAll('*')) {
          if (element.shadowRoot && element.shadowRoot.querySelector(selector)) return true
        }
        return false
      }

      waitForForm(timeoutMs) {
        const started = Date.now()
        return new Promise((resolve) => {
          const check = () => {
            const hosts = this.hosts()
            for (const host of hosts) {
              const form = this.scan(host)
              if (this.ready(form)) return resolve(form)
            }
            // A consumed host (success message, no form) can't produce a
            // fresh form this page view — give up right away.
            const consumed = hosts.length > 0 && hosts.every((host) => !this.scan(host) && this.hasSuccess(host))
            if (consumed || Date.now() - started >= timeoutMs) return resolve(null)
            window.setTimeout(check, 250)
          }
          check()
        })
      }

      watchSuccess(form) {
        // Success = a NEW success node appearing, or the form disappearing —
        // both snapshotted at submit time so nothing pre-existing can
        // false-positive. 12s covers the round trip to forms.shopifyapps.com.
        const selector = '[class*="success" i], [data-success]'
        const root = form.getRootNode()
        const scope = root instanceof ShadowRoot ? root : form.closest('[data-contest-form]') || document.body
        const known = new Set(scope.querySelectorAll(selector))
        const visible = form.isConnected && window.getComputedStyle(form).display !== 'none'
        return new Promise((resolve) => {
          let timer = 0
          const observer = new MutationObserver(() => {
            const gone = !form.isConnected || window.getComputedStyle(form).display === 'none'
            const fresh = Array.from(scope.querySelectorAll(selector)).some((node) => !known.has(node))
            if (fresh || (gone && visible)) {
              observer.disconnect()
              window.clearTimeout(timer)
              resolve(true)
            }
          })
          observer.observe(scope, { childList: true, subtree: true, attributes: true })
          timer = window.setTimeout(() => {
            observer.disconnect()
            resolve(false)
          }, 12000)
        })
      }

      fill(input, value) {
        input.value = value
        input.dispatchEvent(new Event('input', { bubbles: true }))
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["events"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('presale-toggle')) {
    const paneContent = (details) => details.querySelector('.js-events-metaobject__item-details-content')
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches

    customElements.define('presale-toggle', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button')
        if (!button) return
        button.addEventListener('click', () => {
          const details = document.getElementById(this.dataset.target)
          if (!details) return
          if (!details.open) {
            // Accordion: close any other open pane in the same event row so
            // presale / meet & greet / future panes never stack.
            const item = this.closest('.events-metaobject__item')
            if (item) {
              item.querySelectorAll('details.events-metaobject__item-details[open]').forEach((openPane) => {
                if (openPane !== details) this.close(openPane)
              })
            }
            this.open(details, button)
          } else {
            this.close(details, button)
          }
        })
      }

      open(details, button) {
        details.open = true
        button.setAttribute('aria-expanded', 'true')
        const content = paneContent(details)
        if (content && !reduceMotion()) {
          content.animate([{ height: 0 }, { height: content.scrollHeight + "px" }], {
            duration: 300,
            easing: "ease-out",
          })
        }
      }

      close(details, button) {
        // When collapsing a sibling pane, resolve its own toggle button so
        // that button's aria-expanded updates too.
        if (!button) {
          const toggle = document.querySelector(`presale-toggle[data-target="${CSS.escape(details.id)}"] button`)
          if (toggle) button = toggle
        }
        if (button) button.setAttribute('aria-expanded', 'false')
        const content = paneContent(details)
        if (content && !reduceMotion()) {
          const animation = content.animate([{ height: content.scrollHeight + "px" }, { height: 0 }], {
            duration: 300,
            easing: "ease-in-out",
          })
          animation.onfinish = () => details.open = false
        } else {
          details.open = false
        }
      }
    })

    // <details> 'toggle' doesn't bubble; a capture listener keeps the styled
    // button's aria-expanded in sync when the hidden summary or keyboard
    // toggles the panel natively (applies to presale and meet & greet panes).
    document.addEventListener('toggle', (event) => {
      const details = event.target
      if (!(details instanceof HTMLDetailsElement) || !details.id) return
      const toggle = document.querySelector(`presale-toggle[data-target="${CSS.escape(details.id)}"] button`)
      if (toggle) toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false')
    }, true)
  }

  if (!customElements.get('presale-code-readout')) {
    class PresaleCodeReadout extends HTMLElement {
      constructor() {
        super()
        this.presaleCode = false
        this.totalRetryCount = 0
        this.maxRetries = 10
        this.retryFactor = 5
        this.maxDelayMs = 30000
        this.helpTextUpdateInterval = 0
        this.loadingMessageText = "Loading your code..."
      }

      connectedCallback() {
        this.codeRetrievalUrl = this.getAttribute("code-retrieval-url")
        this.render()
      }

      disconnectedCallback() {
        window.clearInterval(this.helpTextUpdateInterval)
      }

      moreRetriesPossible() {
        return this.totalRetryCount < this.maxRetries
      }

      retryCodeRetrieval() {
        if (!this.moreRetriesPossible()) {
          window.clearInterval(this.helpTextUpdateInterval)
          this.updateErrorText()
          return
        }

        // Clamp the exponential backoff and add jitter so a failing endpoint
        // can't produce a ~40-minute single wait or synchronized retry storms.
        const base = Math.min(2 ** this.totalRetryCount * this.retryFactor * 1000, this.maxDelayMs)
        const msToWait = base + Math.floor(Math.random() * 1000)
        this.nextRetryAttemptAt = (new Date()).getTime() + msToWait
        window.setTimeout(this.loadPresaleCode.bind(this), msToWait)

        if (!this.helpTextUpdateInterval) {
          this.helpTextUpdateInterval = window.setInterval(this.updateErrorText.bind(this), 1000)
        }
      }

      async loadPresaleCode() {
        try {
          this.totalRetryCount++
          this.textContent = this.loadingMessageText

          const fetchResult = await fetch(this.codeRetrievalUrl)
          const apiResponse = await fetchResult.json()
          const errorMessage = apiResponse && apiResponse.error
          if (!apiResponse || errorMessage) {
            return this.onPresaleCodeError(errorMessage)
          }
          this.presaleCode = (apiResponse.code_string || "").trim()
          this.onPresaleCodeRetrieved()
        } catch (e) {
          this.onPresaleCodeError(e.message)
        }
      }

      updateErrorText() {
        if (this.moreRetriesPossible()) {
          var retryTimer = Math.floor((this.nextRetryAttemptAt - (new Date()).getTime()) / 1000)
          var retryCount = `${this.totalRetryCount} time`
          if (this.totalRetryCount > 1) {
            retryCount += "s"
          }
          this.errorTextContainer.textContent = `Hold on. We've tried ${retryCount}, but we'll try again in ${retryTimer} seconds...`
        } else {
          this.errorTextContainer.innerHTML = `Sorry, we tried ${this.totalRetryCount} times but it's still not working.<br/><button type="button" class="button-secondary" data-presale-retry>Try again</button> or <a href='/pages/contact'>contact us for help.</a>`
          const retry = this.errorTextContainer.querySelector('[data-presale-retry]')
          if (retry) {
            retry.addEventListener('click', () => {
              this.totalRetryCount = 0
              this.render()
            }, { once: true })
          }
        }
      }

      onPresaleCodeRetrieved() {
        window.clearInterval(this.helpTextUpdateInterval)
        this.helpTextUpdateInterval = 0
        // Build with textContent for the code (never route remote data through innerHTML).
        this.replaceChildren()
        const intro = document.createElement('p')
        intro.className = 'presale-code__text'
        intro.textContent = 'Your unique presale code is'
        const code = document.createElement('p')
        code.className = 'presale-code__string'
        code.textContent = this.presaleCode
        const footer = document.createElement('p')
        footer.className = 'presale-code__footer'
        footer.textContent = "Don't share this code — it's unique to you and can only be used once"
        this.append(intro, code, footer)
        this.setAttribute('data-presale-code', this.presaleCode)
        this.dispatchEvent(
          new CustomEvent("presale-code:available", {
            bubbles: true,
            detail: { presaleCode: () => this.presaleCode },
          })
        )
      }

      onPresaleCodeError() {
        this.replaceChildren()
        const message = document.createElement('p')
        message.className = 'presale-code__text'
        message.textContent = 'Oh no! An unexpected error occurred when fetching your presale code'
        this.errorTextContainer = document.createElement('span')
        this.errorTextContainer.classList.add('presale-retrieval-error-status')
        this.append(message, this.errorTextContainer)
        this.retryCodeRetrieval()
      }

      render() {
        this.textContent = this.loadingMessageText
        this.loadPresaleCode()
      }
    }

    window.customElements.define('presale-code-readout', PresaleCodeReadout)
  }

  if (!customElements.get('mg-entry')) {
    // Meet & greet one-way entry: Enter → locked "Entry Received". There
    // is no cancel — once the customer tag lands, the blocks render a
    // plain disabled confirmation instead of this element. The button is
    // server-rendered in a disabled loading state (spinner visible, label
    // hidden) and only armed here, so a broken script can never show a
    // clickable Enter that goes nowhere.
    //
    // Host: hidden [data-mg-form] wrapper rendered by the events child
    // blocks, holding a Shopify Forms mount div the app embed mounts a
    // React form into (inside an open shadow root). Submissions carry the
    // event handle — Flow adds the mg-<handle> tag.
    const LABELS = { enter: 'Enter', received: 'Entry Received' }

    customElements.define('mg-entry', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button')
        if (!this.button) return
        // A submission made moments ago may not be reflected in the
        // server-rendered state yet (the Flow tag write takes a few
        // seconds) — bridge that gap by landing on the confirmation, but
        // only for 2 minutes: an expired or malformed value is dropped so
        // a tag removed in admin can't stay masked by this tab. Scoped
        // per customer so a shared computer never shows another account's
        // state.
        this.storeKey = `mg-entry:${this.dataset.scope || 'anon'}:${this.dataset.tag}`
        let stored = null
        try { stored = sessionStorage.getItem(this.storeKey) } catch (e) { /* storage blocked */ }
        const age = Date.now() - Number(stored)
        if (stored !== null && age >= 0 && age < 120000) {
          this.lock()
          return
        }
        try { sessionStorage.removeItem(this.storeKey) } catch (e) { /* storage blocked */ }
        this.button.addEventListener('click', () => this.act())
        this.setBusy(false)
      }

      async act() {
        if (window.Shopify && window.Shopify.designMode) {
          this.say('Entry buttons are disabled in the theme editor.')
          return
        }
        if (this.busy || this.locked) return
        this.setBusy(true)

        const form = await this.waitForForm(8000)
        if (!form) {
          this.fail("Sorry — that didn't work. Please refresh the page and try again.")
          return
        }

        const email = this.emailInput(form)
        if (this.dataset.email && email) this.fill(email, this.dataset.email)
        const field = this.fieldInput(form, email)
        if (!field) {
          this.fail('The entry form is missing its Event field.')
          return
        }
        this.fill(field, this.dataset.handle)

        const confirmed = this.watchSuccess(form)
        if (typeof form.requestSubmit === 'function') form.requestSubmit()
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))

        if (!(await confirmed)) {
          this.fail("That didn't seem to go through — please refresh the page and try again.")
          return
        }

        try { sessionStorage.setItem(this.storeKey, String(Date.now())) } catch (e) { /* storage blocked */ }
        this.lock()
      }

      // Terminal state: the disabled button carries the confirmation.
      // locked is set before the busy flag clears so setBusy can never
      // re-arm the button. aria-disabled triggers base.css's native
      // dimming, which covers button-secondary (its :disabled doesn't).
      lock() {
        this.locked = true
        this.say('')
        this.setBusy(false)
        this.button.setAttribute('aria-disabled', 'true')
        const label = this.querySelector('.mg-entry__label')
        if (label) label.textContent = LABELS.received
      }

      fail(message) {
        this.say(message)
        this.setBusy(false)
      }

      // Doubles as the arming step: the server renders the button disabled
      // with the spinner showing, and the first setBusy(false) reveals the
      // live Enter button.
      setBusy(busy) {
        this.busy = busy
        this.button.disabled = busy || this.locked === true
        if (busy) this.button.setAttribute('aria-busy', 'true')
        else this.button.removeAttribute('aria-busy')
        const label = this.querySelector('.mg-entry__label')
        const spinner = this.querySelector('.mg-entry__spinner')
        if (label) label.hidden = busy
        if (spinner) spinner.hidden = !busy
      }

      say(message) {
        const status = this.querySelector('.mg-entry__status')
        if (status) status.textContent = message
      }

      // --- Shopify Forms plumbing. The app embed builds each form as a
      // React app inside an open shadow root; fields commit after the
      // <form> shell does, and shadow renders are invisible to light-DOM
      // observers, so readiness is polled.

      hosts() {
        return Array.from(document.querySelectorAll('[data-mg-form]'))
      }

      scan(host) {
        const direct = host.querySelector('form')
        if (direct) return direct
        for (const element of host.querySelectorAll('*')) {
          if (element.shadowRoot) {
            const form = element.shadowRoot.querySelector('form')
            if (form) return form
          }
        }
        return null
      }

      // The email input isn't always type="email" — the current Forms
      // renderer emits a plain text input identified only by id="email".
      emailInput(form) {
        return form.querySelector('input[type="email"], input[name*="email" i], input[id*="email" i]')
      }

      fieldInput(form, email) {
        const texts = Array.from(form.querySelectorAll('input[type="text"], input:not([type])'))
          .filter((input) => input !== email)
        const named = texts.find((input) => {
          const label = input.labels && input.labels[0] ? input.labels[0].textContent : ''
          return /event/i.test(`${input.name} ${input.id} ${input.placeholder} ${label}`)
        })
        if (named) return named
        return texts.length === 1 ? texts[0] : null
      }

      ready(form) {
        if (!form) return false
        const email = this.emailInput(form)
        return !!email && !!this.fieldInput(form, email)
      }

      hasSuccess(host) {
        const selector = '[class*="success" i], [data-success]'
        if (host.querySelector(selector)) return true
        for (const element of host.querySelectorAll('*')) {
          if (element.shadowRoot && element.shadowRoot.querySelector(selector)) return true
        }
        return false
      }

      waitForForm(timeoutMs) {
        const started = Date.now()
        return new Promise((resolve) => {
          const check = () => {
            const hosts = this.hosts()
            for (const host of hosts) {
              const form = this.scan(host)
              if (this.ready(form)) return resolve(form)
            }
            // A consumed host (success message, no form) can't produce a
            // fresh form this page view — give up right away.
            const consumed = hosts.length > 0 && hosts.every((host) => !this.scan(host) && this.hasSuccess(host))
            if (consumed || Date.now() - started >= timeoutMs) return resolve(null)
            window.setTimeout(check, 250)
          }
          check()
        })
      }

      watchSuccess(form) {
        // Success = a NEW success node appearing, or the form disappearing —
        // both snapshotted at submit time so nothing pre-existing can
        // false-positive. 12s covers the round trip to forms.shopifyapps.com.
        const selector = '[class*="success" i], [data-success]'
        const root = form.getRootNode()
        const scope = root instanceof ShadowRoot ? root : form.closest('[data-mg-form]') || document.body
        const known = new Set(scope.querySelectorAll(selector))
        const visible = form.isConnected && window.getComputedStyle(form).display !== 'none'
        return new Promise((resolve) => {
          let timer = 0
          const observer = new MutationObserver(() => {
            const gone = !form.isConnected || window.getComputedStyle(form).display === 'none'
            const fresh = Array.from(scope.querySelectorAll(selector)).some((node) => !known.has(node))
            if (fresh || (gone && visible)) {
              observer.disconnect()
              window.clearTimeout(timer)
              resolve(true)
            }
          })
          observer.observe(scope, { childList: true, subtree: true, attributes: true })
          timer = window.setTimeout(() => {
            observer.disconnect()
            resolve(false)
          }, 12000)
        })
      }

      fill(input, value) {
        input.value = value
        input.dispatchEvent(new Event('input', { bubbles: true }))
        input.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })

    // Visible diagnostics: append ?fandebug to any URL for an on-page
    // report of what the Forms app mounted into the meet & greet hosts.
    if (window.location.search.indexOf('fandebug') !== -1) {
      window.setTimeout(() => {
        const el = document.querySelector('mg-entry') || document.createElement('mg-entry')
        const lines = [`embeds on page: ${document.querySelectorAll('shopify-forms-embed').length}`]
        document.querySelectorAll('[data-mg-form]').forEach((host) => {
          const form = el.scan(host)
          lines.push(`host: roots=${host.querySelectorAll('[data-form-root]').length} form=${!!form} ready=${el.ready(form)}`)
          if (form) {
            const inputs = Array.from(form.querySelectorAll('input, textarea, select'))
              .map((node) => `${node.tagName.toLowerCase()}[type=${node.type || '?'}][name=${node.name || ''}][id=${node.id || ''}]`)
            lines.push(`  inputs(${inputs.length}): ${inputs.join(' ') || 'NONE'}`)
          }
        })
        const panel = document.createElement('pre')
        panel.style.cssText = 'position:fixed;top:0;left:0;z-index:99999;background:#fff;color:#000;font:12px/1.5 monospace;padding:12px;border:2px solid #000;max-width:90vw;overflow:auto;margin:0;'
        panel.textContent = '[mg-entry debug]\n' + lines.join('\n')
        document.body.appendChild(panel)
      }, 6000)
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["music-tracks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('track-audio')) {
    customElements.define(
      'track-audio',
      class extends HTMLElement {
        connectedCallback() {
          this.audio = this.querySelector('audio');
          this.toggleButton = this.querySelector('.track-audio__toggle');
          if (!this.audio || !this.toggleButton) return;

          this.abortController = new AbortController();
          const signal = this.abortController.signal;

          // Progressive enhancement: swap the native player for the custom button.
          this.audio.controls = false;
          this.audio.setAttribute('hidden', '');
          this.toggleButton.removeAttribute('hidden');

          this.toggleButton.addEventListener(
            'click',
            () => {
              if (this.audio.paused) {
                this.audio.play();
              } else {
                this.audio.pause();
              }
            },
            { signal }
          );

          this.audio.addEventListener(
            'play',
            () => {
              this.updateHint(true);
              // Same shape as the theme's MediaStartedPlayingEvent (assets/events.js),
              // so playing a track pauses theme videos and vice versa.
              const event = new Event('media:started-playing', { bubbles: true });
              event.detail = { resource: this };
              this.dispatchEvent(event);
            },
            { signal }
          );

          this.audio.addEventListener('pause', () => this.updateHint(false), { signal });

          this.audio.addEventListener('ended', () => { this.audio.currentTime = 0; }, { signal });

          document.addEventListener(
            'media:started-playing',
            (event) => {
              if (event.detail && event.detail.resource !== this) this.audio.pause();
            },
            { signal }
          );
        }

        disconnectedCallback() {
          if (this.abortController) this.abortController.abort();
        }

        updateHint(isPlaying) {
          const playIcon = this.toggleButton.querySelector('.icon-play');
          const pauseIcon = this.toggleButton.querySelector('.icon-pause');
          if (playIcon) playIcon.classList.toggle('hidden', isPlaying);
          if (pauseIcon) pauseIcon.classList.toggle('hidden', !isPlaying);
          const label = isPlaying ? this.toggleButton.dataset.labelPause : this.toggleButton.dataset.labelPlay;
          if (label) this.toggleButton.setAttribute('aria-label', label);
        }
      }
    );
  }

  if (!customElements.get('track-lyrics-toggle')) {
    customElements.define(
      'track-lyrics-toggle',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          this.abortController = new AbortController();
          const signal = this.abortController.signal;
          this.button.addEventListener('click', () => this.toggle(), { signal });

          // Keep the button in sync when the details toggles without us
          // (e.g. browser find-in-page auto-expands the panel).
          const details = document.getElementById(this.dataset.target);
          if (details) {
            details.addEventListener(
              'toggle',
              () => this.button.setAttribute('aria-expanded', details.open ? 'true' : 'false'),
              { signal }
            );
          }
        }

        disconnectedCallback() {
          if (this.abortController) this.abortController.abort();
        }

        toggle() {
          const details = document.getElementById(this.dataset.target);
          if (!details) return;

          if (!details.open) {
            this.closeOthers();
            const content = details.querySelector('.music-tracks__lyrics-content');
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            details.open = true;
            this.button.setAttribute('aria-expanded', 'true');
            if (content && !reduce) {
              content.animate([{ height: 0 }, { height: content.scrollHeight + 'px' }], {
                duration: 300,
                easing: 'ease-out',
              });
            }
          } else {
            this.close();
          }
        }

        close() {
          const details = document.getElementById(this.dataset.target);
          if (!details || !details.open || !this.button) return;
          const content = details.querySelector('.music-tracks__lyrics-content');
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.button.setAttribute('aria-expanded', 'false');
          if (content && !reduce) {
            const animation = content.animate(
              [{ height: content.scrollHeight + 'px' }, { height: 0 }],
              { duration: 300, easing: 'ease-in-out' }
            );
            animation.onfinish = () => { details.open = false; };
          } else {
            details.open = false;
          }
        }

        closeOthers() {
          const root = this.closest('.music-tracks');
          if (!root) return;
          for (const other of root.querySelectorAll('track-lyrics-toggle')) {
            if (other !== this) other.close();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nav-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.nav-menu__list-item').forEach(item => {
  const link = item.querySelector('.nav-menu__list-link[aria-haspopup="true"]');
  if (!link) return;
  let touchedOnce = false;
  const openMenu = () => link.setAttribute('aria-expanded', 'true');
  const closeMenu = () => {
    link.setAttribute('aria-expanded', 'false');
    touchedOnce = false;
  };
  link.addEventListener('touchstart', e => {
    if (!touchedOnce) {
      e.preventDefault();
      link.focus();
      touchedOnce = true;
      openMenu();
    } else {
      window.location.href = link.getAttribute('href');
    }
  });
  item.addEventListener('mouseenter', openMenu);
  item.addEventListener('touchstart', openMenu);
  item.addEventListener('mouseleave', closeMenu);
  document.addEventListener('touchstart', e => {
    if (!item.contains(e.target)) closeMenu();
  });
});
  } catch(e) { console.error(e); }
})();

})();
